import type { ComponentProps } from "react";

import { forwardRef } from "react";

const IconShieldCheck = forwardRef<SVGSVGElement, ComponentProps<"svg">>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        color="black"
        {...props}
      >
        <path
          d="M8.54843 9.36831L9.4101 10.3525C9.48926 10.4433 9.63176 10.4358 9.70176 10.3391L11.4518 7.91664M9.55593 17.35C9.68361 17.4472 9.83964 17.4998 10.0001 17.4998C10.1606 17.4998 10.3166 17.4472 10.4443 17.35C11.8068 16.3275 15.8334 12.9883 15.8334 9.17998V5.07164C15.8343 4.96567 15.7958 4.86314 15.7255 4.78387C15.6551 4.7046 15.5579 4.65423 15.4526 4.64248C13.784 4.47164 12.1847 3.88546 10.8009 2.93748L10.2926 2.58998C10.2065 2.53085 10.1045 2.49921 10.0001 2.49921C9.89566 2.49921 9.79368 2.53085 9.7076 2.58998L9.19926 2.93748C7.81548 3.88546 6.21623 4.47164 4.5476 4.64248C4.44227 4.65423 4.34504 4.7046 4.2747 4.78387C4.20436 4.86314 4.1659 4.96567 4.16676 5.07164V9.17998C4.16676 12.9883 8.19343 16.3275 9.55593 17.3483"
          stroke="currentColor"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);
IconShieldCheck.displayName = "IconShieldCheck";

export { IconShieldCheck };
